import React, { useContext, useEffect, useState } from 'react'
import ViewActions from './ViewActions';
import { getProgressStepList, progressStepList, updateReceiptEntryLogs } from './constant';

import { useGetPermissions } from 'layouts/customHook';
import { checkPermission } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { getRoleId } from 'modules/studentTransfer/transferApproval/utils';
import { PermissionContext } from 'appContext';
import ApprovalSentSuccessDialog from 'views/pages/manage/unAssigned/examCharges/examChargesDetails/dialogs/ApprovalSentSuccessDialog';
import BmApprovalAction from './BmApprovalAction';
import TransferTimeline from '../../../studentView/progressTimeLine';
import { getApprovalPermissions, getConfigs, getRefundRequests, updateApprovalRequests } from '../utils';
import moment from 'moment';
import { generateProgressSteps } from 'modules/studentView/constant';
const ProgressAndActionsWrapper = ({ refundFlow, getDetails, details, setLoader: setLoading, applicationId, dropdownData }) => {
  const [isApproval, setIsApproval] = useState()
  const permissions = useContext(PermissionContext);
  const userPermissions = useGetPermissions("studentRefundApproval");
  const isApproverPermission = checkPermission(userPermissions, "A");
  const [approvalActionSuccessDialogInfo, setApprovalActionSuccessDialogInfo] = useState(false);
  const [lastActionInfo, setLastActionInfo] = useState({});

  useEffect(() => {
    permissions && details && getApproval()
  }, [permissions, details])

  const getApproval = async () => {
    try {
      setLoading(true);
      const res = await getRefundRequests({ filters: { applicationId } });
      if (res?.code == 200) {
        const roleId = await getRoleId(permissions?.roleType);
        const approvalConfigs = (await getConfigs({}))?.data ?? [];
        const filterRefundNumberData = (res?.data?.paginatedData ?? [])?.find(item => item.refundNumber == details?.refundNumber)
        const { isL1Approver, isL2Approver, isL3Approver } = getApprovalPermissions({ approvalConfigResponseDTOList: approvalConfigs, roleId, approvalRequest: filterRefundNumberData })
        const approvalStatus = filterRefundNumberData?.approvalStatus
        const isL1Pending = approvalStatus === 'L1_PENDING';
        const isL2Pending = approvalStatus === 'L2_PENDING';
        const isL3Pending = approvalStatus === 'L3_PENDING';
        const approvalPermission = (isL1Pending && isL1Approver || isL2Pending && isL2Approver || isL3Pending && isL3Approver)
        setLastActionInfo({
          updatedOn: filterRefundNumberData?.updatedOn,
          updatedBy: filterRefundNumberData?.updatedBy
        })
        setIsApproval(approvalPermission);
      }
    } catch (err) {
      console.error(err);
    }
    finally {
      setLoading(false);
    }
  }

  const updateStatus = async (reqObj) => {
    try {
      // setLoading(true);
      const resp = await updateApprovalRequests(reqObj)
      if (resp?.code === 200) {
        // successToast("Request completed successfully!");
        const actionDispValue = reqObj?.approvalAction == 'APPROVE' ?
          'Approved' : reqObj?.approvalAction == 'REJECT' ? 'Rejected' : reqObj?.approvalAction == 'RECHECK' ? 'Sent for correction' : '';
        const refundNumber = reqObj?.refundNumber;
        const date = moment().format("DD/MM/YYYY");
        const time = moment().format("hh:mm A");
        setApprovalActionSuccessDialogInfo({
          heading: `Refund request no. ${refundNumber} has been ${actionDispValue.toLowerCase()}.`,
          subHeading: `${actionDispValue} on ${date} at ${time}.`,
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      // setLoading(false);
    }
  };
  // const logs = (details?.logs || []).map((item => ({ ...item, title: item?.event, status: item?.status.toLowerCase() })))
  const { updatedLogList, uniqueTitles } = updateReceiptEntryLogs(details?.logs || [], details?.orderType);
  const steps = generateProgressSteps(getProgressStepList(details?.approvalLevelCount, details?.orderType, uniqueTitles), updatedLogList);
  return (
    <div>
      {isApproval && isApproverPermission && refundFlow == 'approval' && <BmApprovalAction lastActionInfo={lastActionInfo} updateStatus={updateStatus} refundInfo={details} setLoader={setLoading} dropdownData={dropdownData}/>}
      <TransferTimeline
        steps={steps}
        heading='Refund status'
      />
      {details?.orderType !== 'INTERNAL_REFUND' && <ViewActions details={details} steps={steps} refundFlow={refundFlow} />}
      <ApprovalSentSuccessDialog
        open={approvalActionSuccessDialogInfo}
        setOpen={setApprovalActionSuccessDialogInfo}
        heading={approvalActionSuccessDialogInfo?.heading}
        subHeading={approvalActionSuccessDialogInfo?.subHeading}
        closeCb={() => {
          ;
          getDetails();
        }}

      />
    </div>

  )
}
export default ProgressAndActionsWrapper;